import { RotatingLines } from 'react-loader-spinner';
import React from 'react';

const AppLoading = ({
    loadingProgress = 0,
    showProgress = false,
}) => {
    return (
        <div className="htLoading">
            <RotatingLines
                visible={true}
                height="60"
                width="60"
                color="grey"
                strokeWidth="5"
                animationDuration="1.4"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass="" 


            />
            {showProgress && <div className="htLoadingText">{loadingProgress}</div>}
        </div>
    );
}

export default AppLoading;